import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { GoldButton } from '@/components/atoms/GoldButton';

const ScrollToTop = ({ elementId, scrollableElement }) => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    const toggleVisibility = () => {
        if (elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                setIsVisible(element.getBoundingClientRect().bottom < 0);
            }
        } else {
            if (window.scrollY > 1000) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        }
    };

    // Set the top coordinate to 0
    // Make scrolling smooth
    const scrollToTop = () => {
        if (elementId) {
            const element = document.getElementById(elementId);
            element.scrollIntoView({ behavior: "smooth" });
        } else {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };

    useEffect(() => {
        (scrollableElement || window).addEventListener("scroll", toggleVisibility);
        return () => (scrollableElement || window).removeEventListener("scroll", toggleVisibility);
    }, [scrollableElement]);

    return (
        <div className="fixed bottom-0 left-0 right-0">
            <div className={classNames("relative transition-all duration-300 flex justify-center", isVisible
                ? "opacity-100" : "opacity-0")}>
                {/* <div
                    className="absolute w-screen h-40 bottom-0 inset-x-0
                    pointer-events-none
                    bg-gradient-to-t from-black/60 to-transparent 
                    -z-10" /> */}
                <div className='px-4 w-full'>
                    <GoldButton
                        shadow
                        onClick={scrollToTop}
                        className="p-4 bg-gradient-to-r my-8
                     font-medium rounded-xl">
                        START MY FREE TRIAL
                    </GoldButton>
                </div>
            </div>
        </div>
    );
};

export default ScrollToTop; 